import Vue from "./../init";

const uri = "user";

var customActions = {};

const UserResource = Vue.resource(uri, {}, customActions);

export default UserResource;
